import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DigitalStoresService {
    /**
     * Get Digital Stores
     * @param searchTerm
     * @param bnameIdList
     * @param platformList
     * @param loopAccess
     * @param limit
     * @param offset
     * @returns LimitOffsetPage_DigitalStoreFlatExtended_ Successful Response
     * @throws ApiError
     */
    static getDigitalStoresDigitalStoresGet(searchTerm, bnameIdList, platformList, loopAccess, limit = 50, offset) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/digital_stores',
            query: {
                'search_term': searchTerm,
                'bname_id_list': bnameIdList,
                'platform_list': platformList,
                'loop_access': loopAccess,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Deleted Digital Stores
     * @param searchTerm
     * @param bnameIdList
     * @param platformList
     * @param limit
     * @param offset
     * @returns LimitOffsetPage_DeletedDigitalStoreFlat_ Successful Response
     * @throws ApiError
     */
    static getDeletedDigitalStoresDigitalStoresDeletedDigitalStoresGet(searchTerm, bnameIdList, platformList, limit = 50, offset) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/digital_stores/deleted_digital_stores',
            query: {
                'search_term': searchTerm,
                'bname_id_list': bnameIdList,
                'platform_list': platformList,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Deleted Digital Stores Bulk
     * @returns any Successful Response
     * @throws ApiError
     */
    static getDeletedDigitalStoresBulkDigitalStoresDeletedBulkDownloadGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/digital_stores/deleted/bulk/download',
        });
    }
    /**
     * Update Digital Store
     * @param digitalStoreId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateDigitalStoreDigitalStoresDigitalStoreIdPut(digitalStoreId, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/digital_stores/{digital_store_id}',
            path: {
                'digital_store_id': digitalStoreId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Digital Stores
     * @param digitalStoreId
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteDigitalStoresDigitalStoresDigitalStoreIdDelete(digitalStoreId) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/digital_stores/{digital_store_id}',
            path: {
                'digital_store_id': digitalStoreId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Delete Digital Stores From List
     * Bulk delete endpoint for digital stores. It accepts a list of store ids as a string separated by ','.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkDeleteDigitalStoresFromListDigitalStoresBulkDeleteFromListPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/digital_stores/bulk/delete_from_list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Delete Digital Stores
     * Bulk delete endpoint for digital stores. It accepts a csv file with the following columns:
     * id, slug
     *
     * @column id: The id of the deleted digital store to be deleted
     * @column slug: The slug of the deleted digital store to be deleted
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkDeleteDigitalStoresDigitalStoresBulkDeletePost(formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/digital_stores/bulk/delete',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Download Digital Stores
     * @param loopAccess
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkDownloadDigitalStoresDigitalStoresBulkDownloadGet(loopAccess) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/digital_stores/bulk/download',
            query: {
                'loop_access': loopAccess,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Download Digital Stores V2
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkDownloadDigitalStoresV2DigitalStoresBulkDownloadV2Get(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/digital_stores/bulk/download/v2',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Download Unmapped Digital Stores
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkDownloadUnmappedDigitalStoresDigitalStoresUnmappedBulkDownloadGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/digital_stores/unmapped/bulk/download',
        });
    }
    /**
     * Bulk Restore Digital Stores
     * Bulk restore endpoint for digital stores. It accepts a csv file with the following columns:
     * id, slug
     *
     * @column id: The id of the deleted digital store to be restored
     * @column slug: The slug of the deleted digital store to be restored
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkRestoreDigitalStoresDigitalStoresBulkRestorePost(formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/digital_stores/bulk/restore',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Upload Digital Stores
     * Bulk upload endpoint for bnames. It accepts a csv file with the following columns:
     * id, name, address, lat, long, owner_id
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkUploadDigitalStoresDigitalStoresBulkUploadPost(formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/digital_stores/bulk/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Upload Digital Stores V2
     * Bulk upload endpoint for stores. It accepts a csv file with the following columns:
     * platform, store_id, name, bname_id
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkUploadDigitalStoresV2DigitalStoresBulkUploadV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/digital_stores/bulk/upload/v2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
